// Handles accordion animations. Should be loaded at the end of the page.
export default () => {
    const
        details = document.querySelectorAll("nav details"),
        detailsResize = () => {
            for (let detail of details) {
                detail.style.setProperty(
                    "--detailContentHeight",
                    `-${detail.lastElementChild.clientHeight}px`
                );
            }
        },
        summaryClick = (event) => {
            event.preventDefault();
            event.currentTarget.parentNode.classList.toggle("closed");
        },
        radioClick = (event) => {
            let detail = event.currentTarget.parentNode;
            if (detail.classList.contains("closed")) {
                for (target of document.querySelectorAll(
                    `nav details[data-radioname=${detail.dataset.radioname}]`
                )) target.classList.add("closed");
            }
            summaryClick(event);
        };


    for (let detail of details) {
        if (!detail.open) {
            detail.classList.add("closed");
        }
        detail.open = true;
        detail.firstElementChild.addEventListener(
            'click',
            detail.dataset.radioname ? radioClick : summaryClick
        );

        // Get all of the links and see if we should open this accordion
        for (let navLink of detail.querySelectorAll('a')) {
            if (navLink.href === window.location.href) {
                detail.open = true;
                detail.classList.remove("closed");
                break;
            }
        }
    }

    // Blur in the navigation after a little bit
    setTimeout(() => {
        const navs = document.getElementsByClassName('NavAccordion')
        for (let nav of navs) {
            nav.classList.add('loaded');
        }
    }, 300);

    window.addEventListener("resize", detailsResize);
    window.addEventListener("load", detailsResize);
}